<script setup lang="ts">
import { useSound } from '@/composables/useSound'

interface Props {
  backgroundColor?: string
  borderColor?: string
  disabled?: boolean
  noBorder?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  backgroundColor: '#8B4513',
  borderColor: '#8B4513',
  disabled: false,
  noBorder: false
})

defineOptions({
  inheritAttrs: false
})

const { playClick } = useSound()

const emit = defineEmits(['click'])

const handleClick = (event: Event) => {
  playClick()
  emit('click', event)
}
</script>

<template>
  <div class="relative w-max">
    <button
      :disabled="disabled"
      :class="[
        'peer relative w-full z-2 border-[2.5px] rounded-lg p-2.5 flex gap-x-1.5 items-center *:text-sm *:font-bold disabled:cursor-not-allowed transition-all duration-150 not-disabled:hover:brightness-75',
        { 'active:scale-90': noBorder }
      ]"
      :style="{
        backgroundColor: disabled ? '#AEB9CC' : props.backgroundColor,
        borderColor: disabled ? '#6C82A3' : props.borderColor
      }"
      v-bind="$attrs"
      @click="handleClick"
    >
      <slot />
    </button>
    <div
      v-if="!noBorder"
      class="absolute left-0 right-0 -bottom-[5px] lg:-bottom-[7px] h-full transition-all duration-150 rounded-lg peer-active:bottom-0"
      :style="{
        backgroundColor: disabled ? '#6C82A3' : props.borderColor
      }"
    />
  </div>
</template>

<style scoped>
button {
  background-color: var(--bg-color);
}
</style>
